import { render } from "./AdminTrackApprovedRequest.vue?vue&type=template&id=c96a8962"
import script from "./AdminTrackApprovedRequest.vue?vue&type=script&lang=js"
export * from "./AdminTrackApprovedRequest.vue?vue&type=script&lang=js"

import "./AdminTrackApprovedRequest.vue?vue&type=style&index=0&id=c96a8962&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__